<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">SPD Entry Log</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <b>SPD Entry Log</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Pending SPD Entry Log
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="tba_pending_spd_record_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(spd, index) in pending_spd_lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>B$ {{ (Number(spd.sum_covered)).toLocaleString('en-US') }}</td>
                    <td>B$ {{ (Number(spd.amount_paid)).toLocaleString('en-US') }}</td>
                    <td>{{ spd.ncd }}%</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>{{ spd.purchased_at| moment("DD/MM/YYYY H:mm:ss") }}</td>
                    <td>
                      <button class="btn btn-primary btn-block" @click="repush(spd)">Re-push</button>
                      <router-link class="btn btn-primary btn-block" :to="redirect(spd.sys_id, 1)" >View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card text-left my-4">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Fail SPD Entry Log
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="table-responsive">
              <table
                id="tba_fail_spd_record_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Error</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(spd, index) in fail_spd_lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>B$ {{ (Number(spd.sum_covered)).toLocaleString('en-US') }}</td>
                    <td>B$ {{ (Number(spd.amount_paid)).toLocaleString('en-US') }}</td>
                    <td>{{ spd.ncd }}%</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>{{ spd.purchased_at| moment("DD/MM/YYYY H:mm:ss") }}</td>
                    <td>{{ spd.message }}</td>
                    <td>
                      <button class="btn btn-primary btn-block" @click="repush(spd)">Re-push</button>
                      <router-link class="btn btn-primary btn-block" :to="redirect(spd.sys_id, 2)" >View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>

        <br />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getSpdRecords, createSpdRecord } from "@/services/SpdRecordService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "tba_speed_records",
  components: {
    Loading
  },
  data() {
    return {
      success_spd_lists: [],
      fail_spd_lists: [],
      pending_spd_lists: [],
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    async loadSpdEntry() {
      try {
        const response = await getSpdRecords();

        this.pending_spd_lists = response.data.data.pending;
        this.fail_spd_lists = response.data.data.failed;

        for(let x = 0; x < this.fail_spd_lists.length; x++) {
          this.fail_spd_lists[x].type = 'failed'
        }

      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }
    },

    async repush(spd) {
      this.isLoading = true;
      try {
        const response = await createSpdRecord(spd);

        swal("Successfully pushed to SPD", response.data.message, "success")
          .then(async (value) => {
            this.destroyDataTables();
            await this.loadSpdEntry();
            this.setDatatable();
          });
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }
      this.isLoading = false;
    },

    setDatatable() {
      this.loadTable("#tba_pending_spd_record_tbl");
      this.loadTable("#tba_success_spd_record_tbl");
      this.loadTable("#tba_fail_spd_record_tbl");
    },

    destroyDataTables() {
      this.destroyDataTable("#tba_pending_spd_record_tbl");
      this.destroyDataTable("#tba_success_spd_record_tbl");
      this.destroyDataTable("#tba_fail_spd_record_tbl");
    },

    destroyDataTable(id) {
      $(id).DataTable().destroy();
    },

    loadTable(id) {
      $(id).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },

    redirect(id, type) {
      return `/tba/spd_records/${id}/${type}`;
    },
  },
  async created() {
    await this.loadSpdEntry();
    this.setDatatable();
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
